<template>
    <div class="mx-0" :style="{'max-height':height, 'width': width}">
        <apexchart type="pie" :options="chartOptions" :series="series"/>
    </div>
</template>

<script>
export default {
    props: {
        seriesData: {
            type: Array|Object,
            required: true,
        },
        chartLabels: {
            type: Array,
            required: true,
        },
        title: {
            type: String,
            default: '',
        },
        colors: {
            type: Array,
            default: () => ['#1BC5BD', '#FF4560'],
        },
        height: {
            type: String,
            default: '300px'
        },
        width: {
            type: String,
            default: '300px'
        },
        type: {
           type: String,
           default: 'donut'
        },
        showLegend: Boolean
    },
    computed: {
        series() {
            if (Array.isArray(this.seriesData)) {
                return this.seriesData;
            }
            return Object.values(this.seriesData);
        },
        chartOptions() {
            return {
                chart: {
                    type: this.type,
                    height: this.height,
                    width: this.width,
                    offsetX: 0,
                    offsetY: 0,
                },
                labels: this.chartLabels,
                colors: this.colors,
                legend: {
                    show: this.showLegend,
                    position: 'bottom',
                    horizontalAlign: 'center',
                    fontSize: '16px'
                },
                title: {
                    text: this.title,
                    horizontalAlign: 'center',
                },
                tooltip: {
                    y: {
                        formatter: function(value) {
                            return value;
                        }
                    }
                },
            };
        },
    },
};
</script>

